import React, { useState } from 'react';
import Popover from '@mui/material/Popover';
import Upload from '@mui/icons-material/Upload';
import { Button } from '@/ui';
import { ImportPropertySetsPopover } from './ImportPropertySetsPopover';

interface ImportPropertySetsButtonProps {
  setPropertySetsIds: (ids: number[]) => void;
  setPropertySetsValues: (valuesUpdater: (prev: Record<string, never>) => Record<string, never>) => void;
  propertySetsIds: number[];
}

/**
 * MUI's Popover closes itself on an outside click and on Escape, so the hand-rolled
 * `mousedown` listener and the two refs reactstrap's Popover needed are gone.
 */
const ImportPropertySetsButton: React.FC<ImportPropertySetsButtonProps> = ({
  setPropertySetsIds,
  setPropertySetsValues,
  propertySetsIds,
}) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const open = Boolean(anchor);

  return (
    <>
      <Button
        id='importPropertyPopover'
        type='button'
        color='info'
        aria-haspopup='dialog'
        aria-expanded={open || undefined}
        onClick={(event) => setAnchor(event.currentTarget)}
        startIcon={<Upload />}
      >
        Import
      </Button>

      <Popover
        open={open}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        // Dropped below the button rather than beside it: the editor is tall enough that a
        // left-and-centred popover runs off the top of the page from a toolbar button.
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { width: 'min(46rem, 90vw)' } } }}
      >
        <ImportPropertySetsPopover
          setPropertySetsIds={setPropertySetsIds}
          setPropertySetsValues={setPropertySetsValues}
          propertySetsIds={propertySetsIds}
          setIsOpen={(nextOpen) => !nextOpen && setAnchor(null)}
        />
      </Popover>
    </>
  );
};

export default ImportPropertySetsButton;
